import "./invescoGuideAnimation.css";
import "./lngGuideAnimation.css";

/**
 * Inline animated SVG that simulates the L&G fund-centre flow:
 *   0–2s   highlight the "Portafoglio" tab + cursor
 *   2–4s   table appears, cursor moves to the download link
 *   4–6s   "Scarica posizioni complete" pulses + download icon flashes
 *
 * Pure CSS keyframes, self-contained. Same layout footprint as
 * `InvescoGuideAnimation` so both fit the right-side slot in the
 * dialog.
 */
export function LngGuideAnimation() {
  return (
    <div
      data-testid="lng-guide-animation"
      className="lng-guide-anim"
      aria-label="Animazione guida portale L&G"
    >
      <svg viewBox="0 0 200 220" xmlns="http://www.w3.org/2000/svg" role="img">
        {/* Browser chrome */}
        <rect x="2" y="2" width="196" height="216" rx="4" fill="#0a0a0a" stroke="#3f3f46" strokeWidth="1" />
        <rect x="2" y="2" width="196" height="14" rx="4" fill="#18181b" />
        <circle cx="9"  cy="9" r="2" fill="#52525b" />
        <circle cx="16" cy="9" r="2" fill="#52525b" />
        <circle cx="23" cy="9" r="2" fill="#52525b" />
        <text x="100" y="12" fontSize="6" fill="#71717a" textAnchor="middle">fundcentres.landg.com</text>

        {/* Fund header */}
        <rect x="10" y="22" width="120" height="6" rx="1" fill="#52525b" />
        <rect x="10" y="32" width="80"  height="4" rx="1" fill="#3f3f46" />

        {/* Tabs row — "Portafoglio" highlighted in step 1 */}
        <g className="lgr-step1">
          <rect x="10"  y="44" width="40" height="14" rx="2" fill="#27272a" />
          <text x="30"  y="53" fontSize="6" fill="#a1a1aa" textAnchor="middle">Profilo</text>
          <rect x="54"  y="44" width="40" height="14" rx="2" fill="#27272a" />
          <text x="74"  y="53" fontSize="6" fill="#a1a1aa" textAnchor="middle">Costi</text>
          {/* Portafoglio — pulse target */}
          <rect className="lgr-tab-target"
                x="98"  y="44" width="58" height="14" rx="2"
                fill="#065f46" stroke="#10b981" strokeWidth="0.5" />
          <text x="127" y="53" fontSize="6" fill="#a7f3d0" textAnchor="middle"
                fontWeight="600">Portafoglio</text>
        </g>

        {/* Mini table that appears in step 2/3 */}
        <g className="lgr-step2">
          <rect x="10" y="66" width="180" height="6" fill="#27272a" />
          <text x="14" y="71" fontSize="4" fill="#a1a1aa">Description</text>
          <text x="100" y="71" fontSize="4" fill="#a1a1aa">ISIN</text>
          <text x="170" y="71" fontSize="4" fill="#a1a1aa">Weight</text>
          <rect x="10" y="74" width="180" height="6" fill="#0f0f10" />
          <rect x="10" y="82" width="180" height="6" fill="#18181b" />
          <rect x="10" y="90" width="180" height="6" fill="#0f0f10" />
          <rect x="10" y="98" width="180" height="6" fill="#18181b" />
          <rect x="10" y="106" width="180" height="6" fill="#0f0f10" />
          <rect x="10" y="114" width="180" height="6" fill="#18181b" />
          <text x="14" y="125" fontSize="3.5" fill="#52525b">… 64 holdings totali</text>
        </g>

        {/* "Scarica le posizioni complete del fondo" CTA below the table */}
        <g className="lgr-step2">
          <rect className="lgr-btn-target"
                x="20" y="138" width="160" height="16" rx="3"
                fill="#065f46" stroke="#10b981" strokeWidth="0.5" />
          {/* Download arrow icon */}
          <g className="lgr-dl-icon">
            <path d="M 30 142 L 30 148 L 27 148 L 30 152 L 33 148 L 30 148 M 25 153 L 35 153"
                  stroke="#a7f3d0" strokeWidth="1" fill="none" />
          </g>
          <text x="100" y="148" fontSize="5.5" fill="#a7f3d0" textAnchor="middle"
                fontWeight="600">Scarica posizioni complete</text>
          <text x="100" y="152.5" fontSize="3" fill="#6ee7b7" textAnchor="middle">
            del fondo (.csv)
          </text>
        </g>

        {/* Cursor moving from the tab to the CTA */}
        <g className="lgr-cursor">
          <path d="M 0 0 L 0 10 L 3 7 L 5 11 L 7 10 L 4 6 L 8 6 Z"
                fill="#fafafa" stroke="#0a0a0a" strokeWidth="0.5" />
        </g>

        {/* Step labels */}
        <g>
          <rect x="10" y="172" width="180" height="38" rx="3"
                fill="#0a0a0a" stroke="#3f3f46" strokeWidth="0.5" />
          <text x="14" y="184" fontSize="6" fill="#a1a1aa" fontWeight="600">
            <tspan className="lgr-label-1">1. Portafoglio</tspan>
          </text>
          <text x="14" y="196" fontSize="6" fill="#a1a1aa" fontWeight="600">
            <tspan className="lgr-label-2">2. Scarica posizioni</tspan>
          </text>
          <text x="14" y="206" fontSize="5" fill="#71717a">
            CSV pronto per il drop
          </text>
        </g>
      </svg>
    </div>
  );
}
